import { loanProcessingDefinitionsApi, milestoneDefinitionsApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const MILESTONE_DEFINITIONS_ACTION_TYPE = createNamedActions('milestoneDefinitions', {
  GET_MILESTONE_DEFINITIONS_SCHEMA: 'GET_MILESTONE_DEFINITIONS_SCHEMA',
  GET_MILESTONE_DEFINITIONS: 'GET_MILESTONE_DEFINITIONS',
  GET_MILESTONE_PRESENTATION_SETTINGS: 'GET_MILESTONE_PRESENTATION_SETTINGS',
  GET_EXTERNAL_CRM_MILESTONES: 'GET_EXTERNAL_CRM_MILESTONES',
  CREATE_MILESTONE_DEFINITION: 'CREATE_MILESTONE_DEFINITION',
  UPDATE_MILESTONE_DEFINITION: 'UPDATE_MILESTONE_DEFINITION',
  DELETE_MILESTONE_DEFINITION: 'DELETE_MILESTONE_DEFINITION',
  REORDER_MILESTONE_DEFINITION: 'REORDER_MILESTONE_DEFINITION',
  REORDER_MILESTONE_DEFINITION_PENDING: 'REORDER_MILESTONE_DEFINITION_PENDING',
  REORDER_MILESTONE_DEFINITION_REJECTED: 'REORDER_MILESTONE_DEFINITION_REJECTED',
});

const presentationSettingsSchema = new schema.Entity('data', {}, { idAttribute: 'id' });

export const getMilestoneDefinitionsSchemaAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await loanProcessingDefinitionsApi.getMilestoneExpressionDefinition();

  return dispatch({
    type: MILESTONE_DEFINITIONS_ACTION_TYPE.GET_MILESTONE_DEFINITIONS_SCHEMA,
    payload: data,
  });
});

export const getMilestonePresentationSettingsAction = catchAsyncActionError(
  () => async dispatch => {
    const { data } = await milestoneDefinitionsApi.getPresentationSettings();

    return dispatch({
      type: MILESTONE_DEFINITIONS_ACTION_TYPE.GET_MILESTONE_PRESENTATION_SETTINGS,
      payload: normalize(data, [presentationSettingsSchema]).entities.data,
    });
  },
);

export const getExternalCrmMilestonesAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await milestoneDefinitionsApi.getExternalCrmMilestones();

  return dispatch({
    type: MILESTONE_DEFINITIONS_ACTION_TYPE.GET_EXTERNAL_CRM_MILESTONES,
    payload: data,
  });
});

export const getMilestoneDefinitionsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await milestoneDefinitionsApi.getMilestoneDefinitions();

  return dispatch({
    type: MILESTONE_DEFINITIONS_ACTION_TYPE.GET_MILESTONE_DEFINITIONS,
    payload: data,
  });
});

export const createMilestoneDefinitionAction = catchAsyncActionError(
  ({ id, ...params }) =>
    async dispatch => {
      const { data } = await milestoneDefinitionsApi.modifyMilestoneDefinitionCollection({
        create: [params],
      });

      return dispatch({
        type: MILESTONE_DEFINITIONS_ACTION_TYPE.CREATE_MILESTONE_DEFINITION,
        payload: data,
      });
    },
);

export const updateMilestoneDefinitionAction = catchAsyncActionError(
  ({ id, ...params }) =>
    async dispatch => {
      const { data } = await milestoneDefinitionsApi.modifyMilestoneDefinitionCollection({
        update: { [id]: params },
      });

      return dispatch({
        type: MILESTONE_DEFINITIONS_ACTION_TYPE.UPDATE_MILESTONE_DEFINITION,
        payload: data,
      });
    },
);

export const deleteMilestoneDefinitionAction = catchAsyncActionError(id => async dispatch => {
  const { data } = await milestoneDefinitionsApi.modifyMilestoneDefinitionCollection({
    remove: [id],
  });

  return dispatch({
    type: MILESTONE_DEFINITIONS_ACTION_TYPE.DELETE_MILESTONE_DEFINITION,
    payload: data,
  });
});

export const reorderMilestoneDefinitionsAction = ({ orderedIds, reorderedList, currentList }) =>
  catchAsyncActionError(() => async dispatch => {
    const { data } = await milestoneDefinitionsApi.reorderMilestoneDefinitions(orderedIds);

    return dispatch({
      type: MILESTONE_DEFINITIONS_ACTION_TYPE.REORDER_MILESTONE_DEFINITION,
      payload: data,
    });
  })({
    pendingAction: () => ({
      type: MILESTONE_DEFINITIONS_ACTION_TYPE.REORDER_MILESTONE_DEFINITION_PENDING,
      payload: reorderedList,
    }),
    rejectedAction: () => ({
      type: MILESTONE_DEFINITIONS_ACTION_TYPE.REORDER_MILESTONE_DEFINITION_REJECTED,
      payload: currentList,
    }),
  });
